import React from 'react';
import { CheckCircle as CheckCircle2Icon } from '@mui/icons-material';
import { T, fontBody, fontMono } from './tokens';

export default function IntegrationCard({ integration }) {
  const Icon = integration.icon;
  return (
    <div className="sma-card-hover" style={{
      background: T.card, border: `1px solid ${T.line}`, borderRadius: 14,
      padding: '14px 18px', flex: 1, minWidth: 240, display: 'flex', alignItems: 'center', gap: 14,
    }}
    >
      <div style={{ width: 38, height: 38, borderRadius: 10, background: T.blueSoft, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <Icon sx={{ fontSize: 18, color: T.blue }} />
      </div>
      <div style={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, overflow: 'hidden' }}>
          <span style={{ fontFamily: fontBody, fontSize: 14.5, fontWeight: 600, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{integration.label}</span>
          {integration.connected && (
            <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: T.green, fontSize: 11.5, fontFamily: fontBody, fontWeight: 600, flexShrink: 0 }}>
              <CheckCircle2Icon sx={{ fontSize: 12 }} /> Connected
            </span>
          )}
        </div>
        <div style={{ fontFamily: fontMono, fontSize: 12, color: T.slate, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{integration.handle}</div>
        <div style={{ fontFamily: fontBody, fontSize: 12, color: T.slateLight, marginTop: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>Listening: {integration.listens}</div>
      </div>
    </div>
  );
}
